module.exports = __webpack_public_path__ + "static/media/swift_collection.03321982.png";